export enum MedikoRequestType {
  None = 'None',
  WorkerList = 1,
  ManufacturingCharacteristic = 2,
  Telk = 3,
  NewWorker = 4,
  SickLeave = 5,
  ExamAnalysis = 6,
  DeclarationArticle15 = 7,
  Other = 8,
  Queries = 9,
  MailCampaign = 10,
}
